<template>
  <b-container>
    <b-row>
      <b-col cols="12">
        <div class="card-block">
          <div class="card-body p-2">
            <!-- Encabezado -->
            <div class="d-flex align-items-center justify-content-center flex-column p-2">
              <p class="mt-5 mb-2" style="color: #6c757d;">Consulta la actividad de tu equipo docente</p>
              <h1 class="mb-5" style="color: #8b5cf6;">Reportes de la plataforma</h1>
            </div>

            <!-- Texto y botón en 2 columnas -->
            <b-row class="align-items-center my-4 mx-2">
              <b-col cols="12" md="8" class="mb-3 mb-md-0">
                <p class="mb-0" style="color: #333;">
                  Haz clic sobre cada tarjeta para visualizar la información. Puedes descargar un informe completo haciendo clic en descargar concentrado
                </p>
              </b-col>
              <b-col cols="12" md="4" class="text-md-right">
                <b-button class="btn-studioAPP" variant="outline-primary" size="lg" @click="mostrarModalDescarga">
                  <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="currentColor" class="mr-2" viewBox="0 0 16 16" style="vertical-align: middle;">
                    <path d="M.5 9.9a.5.5 0 0 1 .5.5v2.5a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1v-2.5a.5.5 0 0 1 1 0v2.5a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2v-2.5a.5.5 0 0 1 .5-.5z"/>
                    <path d="M7.646 11.854a.5.5 0 0 0 .708 0l3-3a.5.5 0 0 0-.708-.708L8.5 10.293V1.5a.5.5 0 0 0-1 0v8.793L5.354 8.146a.5.5 0 1 0-.708.708l3 3z"/>
                  </svg>
                  Descargar concentrado
                </b-button>
              </b-col>
            </b-row>

            <!-- Tarjetas de Reportes -->
            <div class="row row-cols-1 row-cols-md-3 g-4 mt-3 justify-content-center">
              <!-- Acceso -->
              <div class="col-12 col-md-6 col-lg-4 mb-4">
                <div class="card shadow-sm rounded-3 overflow-hidden border-0 h-100 card-hover d-flex flex-column" @click="navigateTo('ElevaReporteAcceso')">
                  <div class="card-body d-flex flex-column align-items-center text-center p-4" style="border-top-left-radius: 15px; border-bottom-left-radius: 15px; border-left-style: solid; border-left-width: 6px; border-left-color: #8b5cf6;">
                    <div class="icon-circle bg-primary mb-3">
                      <img src="@/assets/images/reports-icons/exit_to_app.svg" alt="Acceso">
                    </div>
                    <h5 class="mb-2 fw-bold">Acceso</h5>
                    <p class="text-muted mb-0" style="font-size: 15px;">
                      Visualiza la última conexión de los usuarios activos por escuela.
                    </p>
                  </div>
                </div>
              </div>

              <!-- Acceso/tiempo -->
              <div class="col-12 col-md-6 col-lg-4 mb-4">
                <div class="card shadow-sm rounded-3 overflow-hidden border-0 h-100 card-hover d-flex flex-column" @click="navigateTo('ElevaReporteAccesoTiempo')">
                  <div class="card-body d-flex flex-column align-items-center text-center p-4" style="border-top-left-radius: 15px; border-bottom-left-radius: 15px; border-left-style: solid; border-left-width: 6px; border-left-color: #ff6600;">
                    <div class="icon-circle bg-warning mb-3">
                      <img src="@/assets/images/reports-icons/timer.svg" alt="Acceso-tiempo">
                    </div>
                    <h5 class="mb-2 fw-bold">Acceso / tiempo</h5>
                    <p class="text-muted mb-0" style="font-size: 15px;">
                      Visualiza los ingresos a la plataforma por usuario, incluyendo fecha, horarios y tiempo estimado de uso.
                    </p>
                  </div>
                </div>
              </div>

              <!-- Acceso por usuario, por día -->
              <div class="col-12 col-md-6 col-lg-4 mb-4">
                <div class="card shadow-sm rounded-3 overflow-hidden border-0 h-100 card-hover d-flex flex-column" @click="navigateTo('AccesosPorUsuarioDia')">
                  <div class="card-body d-flex flex-column align-items-center text-center p-4" style="border-top-left-radius: 15px; border-bottom-left-radius: 15px; border-left-style: solid; border-left-width: 6px; border-left-color: #8b5cf6;">
                    <div class="icon-circle bg-primary mb-3">
                      <img src="@/assets/images/reports-icons/calendar_clock.svg" alt="Acceso por usuario por día">
                    </div>
                    <h5 class="mb-2 fw-bold">Acceso por usuario, por día</h5>
                    <p class="text-muted mb-0" style="font-size: 15px;">
                      Visualiza la primera y última hora de ingreso de cada usuario por día, así como el número total de ingresos.
                    </p>
                  </div>
                </div>
              </div>

              <!-- Horarios de ingreso -->
              <div class="col-12 col-md-6 col-lg-4 mb-4">
                <div class="card shadow-sm rounded-3 overflow-hidden border-0 h-100 card-hover d-flex flex-column" @click="navigateTo('ElevaReporteHorariosIngreso')">
                  <div class="card-body d-flex flex-column align-items-center text-center p-4" style="border-top-left-radius: 15px; border-bottom-left-radius: 15px; border-left-style: solid; border-left-width: 6px; border-left-color: #ff6600;">
                    <div class="icon-circle bg-warning mb-3">
                      <img src="@/assets/images/reports-icons/nest_clock.svg" alt="Horarios de ingreso">
                    </div>
                    <h5 class="mb-2 fw-bold">Horarios de ingreso</h5>
                    <p class="text-muted mb-0" style="font-size: 15px;">
                      Visualiza el número total de ingresos por usuario en cada día, incluyendo el nombre completo del usuario.
                    </p>
                  </div>
                </div>
              </div>

              <!-- Actividades por video -->
              <div class="col-12 col-md-6 col-lg-4 mb-4">
                <div class="card shadow-sm rounded-3 overflow-hidden border-0 h-100 card-hover d-flex flex-column" @click="navigateTo('ActividadesVideo')">
                  <div class="card-body d-flex flex-column align-items-center text-center p-4" style="border-top-left-radius: 15px; border-bottom-left-radius: 15px; border-left-style: solid; border-left-width: 6px; border-left-color: #8b5cf6;">
                    <div class="icon-circle bg-primary mb-3">
                      <img src="@/assets/images/reports-icons/play_pause.svg" alt="Actividades por video">
                    </div>
                    <h5 class="mb-2 fw-bold">Actividades por video</h5>
                    <p class="text-muted mb-0" style="font-size: 15px;">
                      Visualiza todas las acciones de video realizadas por los usuarios (play, pause, ended, etc.) con el tiempo exacto en que se realizaron.
                    </p>
                  </div>
                </div>
              </div>

              <!-- Avance de usuario por curso -->
              <div class="col-12 col-md-6 col-lg-4 mb-4">
                <div class="card shadow-sm rounded-3 overflow-hidden border-0 h-100 card-hover d-flex flex-column" @click="navigateTo('AvanceUsuariosCurso')">
                  <div class="card-body d-flex flex-column align-items-center text-center p-4" style="border-top-left-radius: 15px; border-bottom-left-radius: 15px; border-left-style: solid; border-left-width: 6px; border-left-color: #ff6600;">
                    <div class="icon-circle bg-warning mb-3">
                      <img src="@/assets/images/reports-icons/book_ribbon.svg" alt="Avance de usuario por curso">
                    </div>
                    <h5 class="mb-2 fw-bold">Avance de usuario por curso</h5>
                    <p class="text-muted mb-0" style="font-size: 15px;">
                      Visualiza el porcentaje de avance de cada usuario en sus cursos, con información sobre el estado actual y tiempo transcurrido.
                    </p>
                  </div>
                </div>
              </div>

              <!-- Curso finalizado por usuario -->
              <div class="col-12 col-md-6 col-lg-4 mb-4">
                <div class="card shadow-sm rounded-3 overflow-hidden border-0 h-100 card-hover d-flex flex-column" @click="navigateTo('CursosTerminados')">
                  <div class="card-body d-flex flex-column align-items-center text-center p-4" style="border-top-left-radius: 15px; border-bottom-left-radius: 15px; border-left-style: solid; border-left-width: 6px; border-left-color: #8b5cf6;">
                    <div class="icon-circle bg-primary mb-3">
                      <img src="@/assets/images/reports-icons/flag.svg" alt="Curso finalizado por usuario">
                    </div>
                    <h5 class="mb-2 fw-bold">Curso finalizado por usuario</h5>
                    <p class="text-muted mb-0" style="font-size: 15px;">
                      Visualiza el porcentaje de avance de cada usuario en sus cursos, con información sobre el estado actual y tiempo transcurrido.
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </b-col>
    </b-row>

    <!-- MODAL PARA DESCARGAR REPORTE CONSOLIDADO -->
    <b-modal
      id="modal-descarga-consolidado"
      ref="modalDescarga"
      title="Descargar reporte consolidado"
      size="lg"
      @ok="descargarConcentrado"
      ok-title="Descargar"
      cancel-title="Cancelar"
      ok-variant="primary"
    >
      <p class="mb-3 text-muted">
        Selecciona los filtros para generar el reporte consolidado con todos los datos en un solo archivo Excel con múltiples pestañas.
      </p>

      <b-row>
        <b-col cols="12" 
          v-if="$store.getters.usuario && $store.getters.usuario.roles && ($store.getters.usuario.roles.some(r => r.name === 'admin') || $store.getters.usuario.roles.some(r => r.name === 'docente'))"
        >
          <label><small>Escuela/Dominio</small></label>
          <v-select
            v-model="filtros.escuela"
            :options="filtros.escuelas_items"
            placeholder="Seleccionar escuela"
          >
          </v-select>
        </b-col>

        <b-col cols="12" md="6" class="mt-3">
          <label><small>Fecha inicio</small></label>
          <b-form-datepicker 
            v-model="filtros.fecha_inicio"
            locale="es"
            placeholder="Fecha inicio"
            size="sm"
            label-help=""
            label-today-button="Hoy"
            today-button
            label-no-date-selected="No se ha elegido fecha"
          >
          </b-form-datepicker>
        </b-col>

        <b-col cols="12" md="6" class="mt-3">
          <label><small>Fecha fin</small></label>
          <b-form-datepicker 
            v-model="filtros.fecha_fin"
            locale="es"
            placeholder="Fecha fin"
            size="sm"
            label-help=""
            label-today-button="Hoy"
            today-button
            label-no-date-selected="No se ha elegido fecha"
          >
          </b-form-datepicker>
        </b-col>
      </b-row>

      <b-alert class="mt-3 mb-0" show variant="info">
        <small>
          <strong>Nota:</strong> El reporte incluirá todas las pestañas: Acceso, Acceso/tiempo, Accesos por usuario/día, Horarios de ingreso, Actividades por video, Avance de usuarios por curso y Cursos terminados.
        </small>
      </b-alert>
    </b-modal>
  </b-container>
</template>

<script>
export default {
  name: "ReportesEleva",
  data() {
    return {
      filtros: {
        escuela: { id: 0, label: 'Todas las escuelas' },
        escuelas_items: [],
        fecha_inicio: null,
        fecha_fin: null
      }
    }
  },

  mounted() {
    this.getEscuelas();
  },

  methods: {
    navigateTo(routeName) {
      this.$router.push({ name: routeName });
    },

    mostrarModalDescarga() {
      this.$refs.modalDescarga.show();
    },

    async getEscuelas() {
      try {
        let response = await this.$api.get(`/api/reportes/escuelas`);
        let { success, escuelas } = response.data;
        
        if (success) {
          this.filtros.escuelas_items = escuelas;
        }
      } catch (error) {
        console.error('Error al cargar escuelas:', error);
      }
    },

    async descargarConcentrado() {
      try {
        let params = {
          escuela_id: this.filtros.escuela.id || 0,
          fecha_inicio: this.filtros.fecha_inicio || '',
          fecha_fin: this.filtros.fecha_fin || ''
        };

        const response = await this.$api.get('/api/reportes/consolidado/exportar', {
          params,
          responseType: 'blob',
          headers: { 'Accept': 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, text/csv, application/zip' }
        });

        if (!response.data || response.data.size === 0) {
          throw new Error('No se recibieron datos del servidor');
        }

        // Crear blob para descarga
        const blob = new Blob([response.data], { 
          type: response.headers['content-type'] || 'application/octet-stream' 
        });
        const downloadUrl = window.URL.createObjectURL(blob);
        const link = document.createElement('a');
        link.href = downloadUrl;
        
        // Obtener el nombre del archivo del header Content-Disposition
        let filename = 'reporte_consolidado.xlsx';
        let disposition = response.headers && (response.headers['content-disposition'] || response.headers['Content-Disposition']);
        
        if (disposition && disposition.indexOf('filename=') !== -1) {
          filename = disposition.split('filename=')[1].replace(/['";]/g, '').trim();
        }
        
        link.setAttribute('download', filename);
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        window.URL.revokeObjectURL(downloadUrl);
        
        this.$bvToast.toast('El reporte se ha descargado correctamente.', {
          title: 'Descarga exitosa',
          variant: 'success',
          solid: true,
          autoHideDelay: 3000,
          toaster: 'b-toaster-bottom-center'
        });
      } catch (error) {
        console.error('Error al descargar reporte:', error);
        this.$bvToast.toast(error.message || 'No se pudo descargar el reporte', {
          title: 'Error en la descarga',
          variant: 'danger',
          solid: true,
          autoHideDelay: 5000,
          toaster: 'b-toaster-bottom-center'
        });
      }
    }
  }
};
</script>

<style scoped>
.card{
    border-radius: 15px;
}

.card-hover {
  cursor: pointer;
  transition: transform 0.2s ease-in-out, box-shadow 0.2s ease-in-out;
}

.card-hover:hover {
  transform: translateY(-5px);
  box-shadow: 0 8px 20px rgba(0, 0, 0, 0.15) !important;
}

.fw-bold {
  font-weight: 600;
}

.icon-circle {
  width: 90px;
  height: 90px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
}

.bg-primary {
  background-color: #8b5cf6 !important;
}

.bg-warning {
  background-color: #ff6600 !important;
}
</style>
